<template>
	<div class="right flex-column">
		<div class="recommend">
			<div class="subTitle">推荐关注</div>
			<div class="list">
				<div class="item flex-row align-center" v-for="(item, index) in attentionList">
					<div class="flex-row align-center">
						<div class="flex-row flex-center"><img :src="logoUrl" alt=""></div>
						<div>{{ item.titel }}</div>
					</div>
					<el-tooltip placement="left" effect="light">
						<div slot="content" style="width: 180px;height: 180px;" class="flex-column"><img :src="item.QRCode" width="100%" /></div>
						<div class="nav-item flex-column cursor">+关注</div>
					</el-tooltip>
				</div>
			</div>
		</div>
		<div class="QRCode"><img src="@/assets/complianceStudy/qrCode.png" alt=""></div>
		<div class="recommend2">
			<div class="subTitle">相关推荐</div>
			<div class="recommendShell">
				<el-carousel arrow="never" height="308px" trigger="click">
					<el-carousel-item v-for="(item, index) in Math.ceil(list.length/3)" :key="index">
						<div class="list">
							<div @click="to2(item.url)" class="cursor item flex-row align-center" v-for="item in list.slice(index==0?index:index*3, index=0?3:(index+1)*3)">
								<div><el-image :src="item.advertisingPic" fit="cover"></el-image></div>
								<div>{{ item.title }}</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['attentionList', 'list'],
	data() {
		return {
			logoUrl: require('@/assets/complianceStudy/logo.png')
		};
	},

	methods: {
		to2(url){
			window.open(url)
		},
	}
};
</script>

<style lang="scss" scoped>
.right {
	.subTitle {
		font-size: 24px;
		font-weight: 400;
		color: #333333;
		margin-top: 37px;
		margin-left: 35px;
	}
	justify-content: space-between;
	.recommend {
		width: 394px;
		height: 460px;
		background: linear-gradient(180deg, #f5f7f8 0%, #ffffff 100%);
		box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
		border: 1px solid #ffffff;

		.list {
			margin-top: 39px;
			margin-left: 36px;
			width: 320px;
			> :not(:first-child) {
				margin-top: 15px;
			}
			.item {
				justify-content: space-between;
				> :first-child {
					:first-child {
						text-align: center;
						line-height: 40px;
						width: 40px;
						height: 40px;
						border-radius: 6px;
					}
					:nth-child(2) {
						margin-left: 20px;
						font-size: 16px;
						font-weight: 400;
						color: #333333;
					}
				}
				> :last-child {
					width: 61px;
					height: 30px;
					background: rgba(41, 112, 236, 0.26);
					border-radius: 8px;
					font-size: 14px;
					line-height: 30px;
					text-align: center;
					font-weight: 400;
					color: #2970ec;
				}
			}
		}
	}
	.QRCode {
		width: 394px;
		height: 395px;
		text-align: center;
		line-height: 395px;
		font-size: 32px;
	}
	.recommend2 {
		width: 394px;
		height: 393px;
		background: linear-gradient(180deg, #f5f7f8 0%, #ffffff 100%);
		box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
		border: 1px solid #ffffff;
		.list {
			width: 339px;
			margin: 0 auto;
			margin-top: 25px;
			margin-left: 36px;
			> :not(:first-child) {
				margin-top: 20px;
			}
			.item {
				justify-content: space-between;
				> :first-child {
					width: 149px;
					height: 63px;
					line-height: 63px;
					font-size: 28px;
					text-align: center;
				}
				> :last-child {
					width: 176px;
					height: 44px;
					font-size: 16px;
					font-weight: 400;
					color: #333333;
					overflow:hidden;
					text-overflow:ellipsis;
					display:-webkit-box;
					-webkit-line-clamp:2;
					-webkit-box-orient:vertical;
					word-break:break-all;
				}
			}
		}
	}
}
</style>
